<template>
    <page title="reloading">
        <template #pageContainer>
            <div>
                {{ $t('text.reloading') }}
            </div>
        </template>
    </page>
</template>

<script>
import Page from './Page.vue';

export default {
	name: 'Redirector',
	components: {
		Page,
	},
	mounted() {
		this.$router.go(-1);
	},
};
</script>
